import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/home'
import viewRoot from './views/viewRoot.vue'
const NotFound = () => import('./views/errorPage/404.vue')
const index = () => import('./views/index');
const Login = () => import('./views/login');
const Iframe = () => import('./views/iframe');
const refresh = () => import('./views/errorPage/empty.vue');


// 民情在线
const peopleOnlineSrc = './views/peopleOnline/'
const peopleOnline = {
  volunteer: () => import(`${peopleOnlineSrc}volunteer`),
  volunteerDetail: () => import(`${peopleOnlineSrc}volunteer/detail`),
  volunteerAdd: () => import(`${peopleOnlineSrc}volunteer/add`)
}

// 通知新闻
const newsSrc = './views/news/'
const news = {
  address: () => import(`${newsSrc}address`),
  addressAdd: () => import(`${newsSrc}address/add`),

  publicAcc: () => import(`${newsSrc}publish`),
  imgTextAdd: () => import(`${newsSrc}publish/imgText/add`),
  imgTextDetail: () => import(`${newsSrc}publish/imgText/detail`),

  floorNum: () => import(`${newsSrc}floorNum`),
  floorNumAdd: () => import(`${newsSrc}floorNum/add`),
}

// 平台配置
const platformConfigSrc = './views/platformConfig'
const platformConfig = {
  // 安卓发文
  andriodPublish: () => import(`${platformConfigSrc}/andriodPublish/index`),
  imgTextAdd: () => import(`${platformConfigSrc}/andriodPublish/add`),
  imgTextDetail: () => import(`${platformConfigSrc}/andriodPublish/detail`),

  // 动态表单
  formMaking: () => import(`${platformConfigSrc}/formManager/index`),
  formMakingAdd: () => import(`${platformConfigSrc}/formManager/add`),
}
// 静态图表
const chartsSrc = './views/charts'
const chartsConfig = {
  // 安卓发文
    serviceCharts: () => import(`${chartsSrc}/serviceCharts`),
    serviceCharts2: () => import(`${chartsSrc}/serviceCharts2`),
    serviceCharts3: () => import(`${chartsSrc}/serviceCharts3`)
}

// 应用订阅
const appConfiguration = () => import('./views/appConfiguration')

// 音视频通话
const videoCall =()=> import('./views/videoCall')
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      component: Login,
      name: 'login',
      hidden: true
    },
    {
      path: '/404',
      component: NotFound,
      name: '404',
      hidden: true
    },
    {
      path: '',
      component: Home,
      hidden: true,
      name: 'Index',
      redirect: 'index',
      children: [
        { path: 'index', component: index, name: 'index', meta: { name: 'index' } },
      ]
    },
    // 刷新页面跳转的空白页
    {
      path: '/refresh',
      component: Home,
      children: [
        { path: '', component: refresh, name: 'refresh', meta: { name: '刷新页面' } },
      ]
    },
    {
      path: '/iframe',
      component: Home,
      children: [
        { path: '', component: Iframe, name: 'iframe', meta: { name: 'iframe', keepAlive: true } },
      ]
    },
    // 民情在线 志愿者管理
    {
      path: '/peopleOnline',
      component: Home,
      name: 'peopleOnline',
      children: [
        {
          path: 'volunteer',
          component: viewRoot,
          children: [
            { path: '', component: peopleOnline.volunteer, name: 'peoVolunteer', meta: { name: '志愿者活动' } },
            { path: 'detail', component: peopleOnline.volunteerDetail, name: 'peoVolunteerDetail', meta: { name: '志愿者编辑和查看操作', hidden: true } },
            { path: 'add', component: peopleOnline.volunteerAdd, name: 'peoVolunteerAdd', meta: { name: '志愿者添加', hidden: true } },
          ]
        },
      ]
    },
    {
      path: '/appConfiguration',
      component: Home,
      children: [
        { path: '', component: appConfiguration, name: 'appConfiguration', meta: { name: '应用配置' } },
      ]
    },
    // 平台配置
    {
      path: '/platformConfig',
      component: Home,
      name: 'platformConfig',
      children: [
        // 安卓发文/运营信息
        {
          path: 'androidPublish',
          component: viewRoot,
          children: [
            { path: '', component: platformConfig.andriodPublish, name: 'androidPublish', meta: { name: '安卓文章推送' } },
            { path: 'imgTextAdd', component: platformConfig.imgTextAdd, name: 'androidImgTextAdd', meta: { name: '图文添加', hidden: true } },
            { path: 'imgTextDetail', component: platformConfig.imgTextDetail, name: 'androidImgTextInfo', meta: { name: '图文详情', hidden: true } },
          ]
        },
        // 动态表单
        {
          path: 'formMaking',
          component: viewRoot,
          children: [
            { path: '', component: platformConfig.formMaking, name: 'formMaking', meta: { name: '表单列表' } },
            { path: 'add', component: platformConfig.formMakingAdd, name: 'formAdd', meta: { name: '表单添加', hidden: true } },
          ]
        },
      ]
    },
    // 通知新闻
    {
      path: '/news',
      component: Home,
      name: 'news',
      children: [
        {
          path: 'address',
          component: viewRoot,
          children: [
            { path: '', component: news.address, name: 'newsAddress', meta: { name: '地名地址' } },
            { path: 'add', component: news.addressAdd, name: 'addressAdd', meta: { name: '地名地址添加', hidden: true } },
          ]
        },
        {
          path: 'publish',
          component: viewRoot,
          children: [
            { path: '', component: news.publicAcc, name: 'newsPublicAcc', meta: { name: '发文管理' } },
            { path: 'imgTextAdd', component: news.imgTextAdd, name: 'newsImgTextAdd', meta: { name: '图文添加', hidden: true } },
            { path: 'imgTextDetail', component: news.imgTextDetail, name: 'newsImgTextDetail', meta: { name: '图文详情', hidden: true } },
          ]
        },
        {
          path: 'floorNum',
          component: viewRoot,
          children: [
            { path: '', component: news.floorNum, name: 'newsFloorNum', meta: { name: '楼门牌' } },
            { path: 'add', component: news.floorNumAdd, name: 'floorNumAdd', meta: { name: '楼门牌添加', hidden: true } },
          ]
        },
      ]
    },
    {
      path: '*',
      name: 'NotFound',
      hidden: true,
      component: NotFound
    },
      {
          path: '/videoCall',
          name: 'videoCall',
          hidden: true,
          component: videoCall
      },
      // 图表
      {
          path: '/serviceCharts',
          name: 'serviceCharts',
          meta: {
              requireAuth: false
          },
          component: chartsConfig.serviceCharts
      },
      // 临时加的eCharts
      {
          path: '/serviceCharts2',
          name: 'serviceCharts2',
          meta: {
              requireAuth: false
          },
          component:  chartsConfig.serviceCharts2
      },
      // 临时加的eCharts
      {
          path: '/serviceCharts3',
          name: 'serviceCharts3',
          meta: {
              requireAuth: false
          },
          component:  chartsConfig.serviceCharts3
      },
  ]
})
